import Solution from "./solution";
import compare from "../../Utils/compare";

const testCases = [
  {
    arr: [1, 2, 3, 4, 5, 6],
  },
  {
    arr: [1, 2, 2, 3, 3, 3],
  },
  {
    arr: [1, 1, 2, 2, 3, 3, 3, 5],
  },
  {
    arr: [2, 2, 2, 3, 3, 3, 4, 4, 4, 2, 5, 5, 5, 6, 6],
  },
  {
    arr: [1, 1, 2, 2, 3, 3],
  },
];

const test = (code) => {
  try {
    const updatedFunc = `${code.trim()}`;
    const output = new Function(updatedFunc);
    for (let test of testCases) {
      const { arr } = test;
      let outcome1 = output()(arr);
      let outcome2 = Solution(arr);
      const result = outcome1 == outcome2;
      if (!result) {
        return {
          status: "failed",
          details: { input: test, output: outcome1, expected: outcome2 },
        };
      }
    }

    return { status: "success", details: {} };
  } catch (e) {
    return {
      status: "error",
      details: { message: `${e.name}: ${e.message}` },
    };
  }
};

export default test;
